export var messages = {
    validation : {
        emailRegx : /^[A-Za-z0-9._%+-]{1,}@[a-zA-Z]{2,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$/,
        nameRegex : /^[a-zA-Z]{3,15}[,. -]{1}[a-zA-Z ]{3,15}$/,
        characterOnly: /^[\p{L}]+(?:[\s'-][\p{L}]+)*\s*$/u  
    }
    
  };


